module.exports = __webpack_public_path__ + "static/media/tour-popup-fig-5.e8d21c80.png";